module.exports = __webpack_public_path__ + "static/media/undraw_Graduation_ktn0.8c7975ec.svg";